module.exports = __webpack_public_path__ + "static/media/A7.70d7d48e.jpg";